import React, {useEffect, useState} from 'react';
import {makeStyles} from '@mui/styles';
import Box from '@mui/material/Box';
import Dialog from '@mui/material/Dialog';
import Slide from '@mui/material/Slide';
import UniversalPricingTable from '../../../../../common/UniversalPricingTable';
import useScreenWidth from '../../../../../hooks/useScreenWidth';
import {useRecoilValue, useSetRecoilState} from 'recoil';
import {loadingState} from '../../../../../recoil/bidmiiCustomLoader/bidmiiCustomLoaderAtom';
import {
  fetchRequest,
  securedFetchRequest,
} from '@bidmii/common/lib/util/FetchRequest';
import {API_URL} from '../../../../../constants';
import {firePurchase} from '../../../../../util/Analytics';
import {userState} from '../../../../../recoil/user/userAtom';
import * as Sentry from '@sentry/react';
import {theme} from '../../../../../Theme';
import ToolbarHeader from '../../../../../common/ToolbarHeader';
import useDiscountCode from '../../../../../hooks/useDiscountCode';
import {LazyStripePaymentFlow} from '../../../../../common/LazyLoader';

const Transition = React.forwardRef(function Transition(props, ref) {
  // @ts-expect-error ts-migrate(2322) FIXME: Type '{ children?: ReactNode; direction: "up"; ref... Remove this comment to see the full error message
  return <Slide direction="up" ref={ref} {...props} />;
});

const useStyles = makeStyles(() => ({
  root: {
    overflowY: 'auto',
    height: window.outerWidth > 600 ? '70vh' : '100vh',
    //marginBottom: 100,
    paddingLeft: window.outerWidth > 600 ? 20 : 10,
    paddingRight: window.outerWidth > 600 ? 20 : 10,
  },
  promotionCard: {
    border: `1px solid ${theme.palette.gray.border}`,
    marginTop: 8,
  },
  closeIcon: {
    cursor: 'pointer',
    position: 'absolute',
    right: 8,
    top: 12,
  },
  promotionBox: {
    marginTop: 8,
    padding: 12,
    borderRadius: 10,
    border: `1px solid ${theme.palette.gray.border}`,
  },
}));

const PROMOTION_PRICE = 14.99;

export default function PromoteProjectDialog(props: $TSFixMe) {
  const classes = useStyles();
  const width = useScreenWidth();
  const user = useRecoilValue(userState);

  const setLoading = useSetRecoilState(loadingState);

  const [clientSecret, setClientSecret] = useState<string>();

  const [promoteProjectDialogOpen, setPromoteProjectDialogOpen] = useState(
    props.open || props.requestForProposal.meta.proposalsCount === 0 || false,
  );

  const [DiscountCodeInput, discountCode, discount] = useDiscountCode({
    setLoading,
    price: PROMOTION_PRICE,
  });

  const getNonceData = () => {
    const productIds = `PROMOTED_RFP_EXPRESS`;

    const body = {
      productIds,
      recId: props.requestForProposal?.id,
      recModel: 'REQUEST_FOR_PROPOSAL',
      promoCode: discountCode,
      redirectUrl: `${window.location.origin}/myRfps/${props.requestForProposal.uid}?payment_type=project_promotion`,
      productType: 'RFP_PROMOTION',
    };

    const requestFunction = !user ? fetchRequest : securedFetchRequest;
    const options = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
    };
    if (!user) {
      // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
      options.headers['Firebase-Authorization'] = sessionStorage.getItem(
        'Firebase-Authorization',
      );
    }
    return requestFunction(`${API_URL}/create-payment-intent`, options)
      .then((response) => response.text())
      .then((CLIENT_TOKEN_FROM_SERVER) => {
        setLoading(false);
        setClientSecret(CLIENT_TOKEN_FROM_SERVER);
      })
      .catch((err) => {
        process.env.NODE_ENV === 'development' && console.error(err);
        setLoading(false);
        Sentry.withScope(function (scope) {
          scope.setTag('section', 'StripePaymentFlow.tsx getNonceData()');
          Sentry.captureException(err);
        });
      });
  };

  useEffect(() => {
    setLoading(true);
    if (
      user?.initialised ||
      props.anonymous ||
      localStorage.getItem('isAnonymous') === '1'
    ) {
      getNonceData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  const handleClose = (event: any) => {
    setPromoteProjectDialogOpen(false);
    props.handleClose(event);
  };

  const getPricingData = () => {
    const data = [
      {
        title: 'PROJECT PROMOTION',
        amount: PROMOTION_PRICE,
        negative: false,
      },
    ];

    if (Number(discount) > 0) {
      data.push({
        title: 'DISCOUNT',
        amount: Number(discount),
        negative: true,
      });
    }

    return data;
  };

  const getSubtotal = () => {
    return PROMOTION_PRICE - Number(discount);
  };

  // const secondaryText =
  //   props.requestForProposal.meta.proposalsCount === 0
  //     ? 'There are currently no quotes to review. You can promote your project to ensure it stays at the top of the list and gets more visibility from contractors.'
  //     : 'Promoting your project ensures it stays at the top of the list and gets more visibility from contractors.';

  return (
    <>
      <Dialog
        open={promoteProjectDialogOpen}
        // @ts-expect-error ts-migrate(2322) FIXME: Type 'ForwardRefExoticComponent<RefAttributes<unkn... Remove this comment to see the full error message
        TransitionComponent={Transition}
        maxWidth="sm"
        fullWidth
        fullScreen={width <= 600}
        PaperProps={{
          style: {
            borderRadius: width > 600 ? 10 : 0,
          },
        }}>
        <ToolbarHeader title="PROMOTE YOUR PROJECT" handleClose={handleClose} />
        <div
          className={classes.root}
          id="promotionScrollDiv"
          onClick={(event) => event.stopPropagation()}>
          <Box my={3}>
            {DiscountCodeInput}

            <UniversalPricingTable
              pricingData={getPricingData()}
              subtotal={getSubtotal()}
            />
            <LazyStripePaymentFlow
              redirectUrl={`${window.location.origin}/myRfps/${props.requestForProposal.uid}?payment_type=project_promotion`}
              clientSecret={clientSecret}
              onConfirmPayment={() => {
                firePurchase(
                  PROMOTION_PRICE,
                  `${user?.id || ''}_promoted_project`,
                );
              }}
            />
          </Box>
        </div>
      </Dialog>
    </>
  );
}
